import { useSession } from 'next-auth/react';
import useSWR from 'swr';
import { CurrentAgentStatus, customSWRConfig, customSWRResponse } from '../../model/types';
import useSWRCacheKeys from '../useSWRCacheKeys';

export default function useAgentStatus(config: customSWRConfig = {}): customSWRResponse<CurrentAgentStatus> {
    const { data: session } = useSession();

    const keys = useSWRCacheKeys(
        session?.userInfo?.username ? `/users/${session?.userInfo?.username}/status/current` : null
    );

    return useSWR<CurrentAgentStatus>(keys, { ...config });
}
